import getKey from "./getKey";

const pathParse = (pathString) => {
    return pathString.replace(/\[/g, '.').replace(/\]/g, '.').split('.').filter(k => k);
}

export const setKey = (object, path, value) => {
    if (!object) return {};
    if (typeof object !== "object") return {};
    if (!path) return {};
    if (typeof path !== "string") return object;
    const pathArray = pathParse(path);
    let index = pathArray.length - 1;
    let endpoint = value;
    let retour = { ...object };

    while (index >= 0) {

        if (!isNaN(pathArray[index])) {
            if (!Array.isArray(endpoint)) {
                endpoint = [];
            }
            endpoint[pathArray[index]] = value;
        } else if (typeof getKey(retour, `${pathArray.slice(0, index + 1).join(".")}`) === "undefined") {
            if (typeof getKey(retour, `${pathArray.slice(0, index).join(".")}`) !== "undefined") {
                let tmp = getKey(retour, `${pathArray.slice(0, index).join(".")}`)
                endpoint = { ...tmp, ...{ [`${pathArray[index]}`]: endpoint } };
            } else {
                endpoint = { [`${pathArray[index]}`]: endpoint };
            }
            if (!index) {
                retour = { ...retour, ...endpoint };
                break;
            }
        }
        else {
            let i, targetKey = retour;
            for (i = 0; i < index; i++) {
                targetKey = targetKey[`${pathArray[i]}`]
            }
            targetKey[`${pathArray[i]}`] = endpoint;
            break;
        }
        index--;
    }
    let ret = { ...retour }
    return ret;

};

export default setKey;